import baseAPI from './baseAPI'

const getGeneral = async () => {
    return await baseAPI.get('general')
}

export default { getGeneral }